export enum FacilityInputType {
    Date = 1,
    Decimal = 2,
    Select = 3,
    Text = 4,
    Textarea = 5,
    Number = 6
}

export enum FacilityFieldType {
    Date = 1,
    Decimal = 2,
    Integer = 3,
    String = 4,
    Boolean = 5
}

export enum PackageStatus {
    Draft = 1,
    Active = 2,
    Closed = 3
}

export enum Mode {
    Add = 'add',
    Edit = 'edit',
    View = 'view',
    Create = 'create',
    Configure = 'configure'
}

export interface IMenuAction { id: number, isActive: boolean }

export interface ActionMenuItem {
    label: string;
    icon: string;
    permission?: string;
    emitValue?: any;
    colorClass?: string;
    actionType?: string;
    type?: string;
    action?: () => {}
}



export interface ApiResponse<T> {
    success: boolean;
    statusCode: number;
    message: string;
    data: T;
    errorCode: string | null;
}

export enum AccountType {
    Company = 1,
    Individual = 2
}